// @flow
import React from "react";
import {connect} from "react-redux";
import AcceptTerms from "./AcceptTerms/AcceptTerms";
import {constants, strings} from "../../../config";
import {WelcomePageTitle, WelcomePageDisclaimer, WelcomePageContent, UnderTopBarWelcomeFloater} from "./WelcomePageStyle";
import reactStringReplace from "react-string-replace";
import GradientBackdropWithVan from "../../GradientBackdrop/GradientBackdropWithVan";


const buildPolicyString = () => {
    let policyTempString = reactStringReplace(
        strings.welcome_page_disclaimer, "{acceptButton}", (match, i) => strings.welcome_page_button_text);
    policyTempString = reactStringReplace(
        policyTempString, "{termsOfUse}", (match, i) => <a key={0} href={constants.TERMS_OF_USE_LINK}>Terms of use</a>);
    policyTempString = reactStringReplace(
        policyTempString, "{policy}", (match, i) => <a key={1} href={constants.POLICY_LINK}>Policy</a>);

    return policyTempString;
};

const policyString = buildPolicyString();

const WelcomePage = props => {
    return (
        <GradientBackdropWithVan>
            <UnderTopBarWelcomeFloater>
                <WelcomePageTitle>
                    {reactStringReplace(strings.welcome_page_title, "{riderName}",
                        () => props.tokenData.first_name)}
                </WelcomePageTitle>
                <WelcomePageContent>
                    {strings.welcome_page_content}
                </WelcomePageContent>
                <AcceptTerms/>
                <WelcomePageDisclaimer>
                    {policyString}
                </WelcomePageDisclaimer>
            </UnderTopBarWelcomeFloater>
        </GradientBackdropWithVan>
    );

};

const mapStateToProps = (state, props) => {
    return {
        tokenData: state.tokenData,
    };
};

export default connect(mapStateToProps)(WelcomePage);



// WEBPACK FOOTER //
// ./src/Components/Screen/WelcomePage/WelcomePage.js